/**
 * The ≤768px switch every `X.mobile.jsx` fork is chosen by.
 *
 * This used to be a local implementation — `window.innerWidth` read at hook
 * init plus a `resize` listener — sitting beside a byte-identical copy in
 * `@parsina/framework`. Two implementations of "is this a phone" is one more
 * than a product can have: the framework's own components (`AccountCard`'s
 * `overlay="auto"`, `AuthShell`) switch on the KIT's answer, so a divergence
 * of even one pixel renders a screen half in each mode.
 *
 * The kit's version is also the better one: it listens on `matchMedia` rather
 * than `resize` (no layout read per resize frame, and it fires on an
 * orientation change that does not alter `innerWidth`), and it guards for a
 * missing `window` instead of throwing at import time.
 *
 * 768 is the ONLY mobile boundary in this app — `styles.css`'s media block and
 * the shell fork in `ClinicLayout.jsx` key off the same number.
 * See docs/MOBILE-REDESIGN.md §3.1.
 */
import { useResponsive } from '@parsina/framework';

export { useResponsive };
export default useResponsive;
